import * as app from 'durandal/app';
import * as system from 'durandal/system';

import * as companyService from '@/legacy/services/company';
import * as companyPaymentService from '@/legacy/services/company/payment';
import * as userService from '@/legacy/services/user';
import * as plootoUtils from '@/legacy/utils/plooto';

const API_PREFIX = 'v1';

export class PromoCodeApplyCodeViewModel {
  public id: string;

  public expiry: string;

  public totalFreeTransactions: number;

  public addedFreeTransactions: number;
}

export class PromoCodeService {
  private companyService: companyService.CompanyService;

  private userService: userService.UserService;

  constructor() {
    this.companyService = companyService.Instance;
    this.userService = userService.Instance;

    this.BindPaymentEventCallbacks();
  }

  private BindPaymentEventCallbacks() {
    // Bind to a few extra events so we can adjust our free transactions accordingly
    app.on('payment:create').then((createdPayment: companyPaymentService.Payment) => {
      const { freeTransactions } = this.companyService.profile();
      if (createdPayment.freeTransactionUsed()) {
        freeTransactions(freeTransactions() - 1); // Remove 1 free transaction
      }
    });

    const decreaseFreeTransaction = (deletedPayment: companyPaymentService.Payment) => {
      const { freeTransactions } = this.companyService.profile();
      if (deletedPayment.freeTransactionUsed()) {
        freeTransactions(freeTransactions() + 1); // Add back 1 free transaction
      }
    };

    app.on('payment:delete').then(decreaseFreeTransaction);
    app.on('payment:reject').then(decreaseFreeTransaction);
  }

  public PutApplyCode(code: string): JQueryPromise<PromoCodeApplyCodeViewModel> {
    const companyId: string = this.companyService.CompanyId();
    if (companyId === undefined) {
      return undefined;
    }

    return system
      .defer<PromoCodeApplyCodeViewModel>((dfd) => {
        this.userService
          .AuthorizedPut(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/companies/${companyId}/promoCodes/applyCode`,
            {
              code,
            }
          )
          .done((exchangeRateData) => {
            if (
              plootoUtils.IsNullOrUndefined(exchangeRateData) ||
              exchangeRateData.error === true
            ) {
              dfd.reject(exchangeRateData);
              return;
            }
            dfd.resolve(exchangeRateData);
          })
          .fail(() => {
            dfd.reject();
          });
      })
      .promise();
  }
}

export const Instance = new PromoCodeService();
